import { Cursor as CursorCore } from '@studiometa/ui';
import { gsap } from 'gsap';
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin';

/**
 * Cursor
 */
export default class Cursor extends CursorCore {
  static config = {
    ...CursorCore.config,
    refs: ['title', 'year'],
  };

  /**
   * Register gsap plugin
   * @returns {void}
   */
  mounted() {
    gsap.registerPlugin(ScrambleTextPlugin);
  }

  /**
   * Moved hook.
   * @param {object} props service props
   * @param {Event} props.event
   * @param {number} props.x
   * @param {number} props.y
   * @param {boolean} props.isDown
   */
  moved({ event, x, y, isDown }) {
    if (!this.$services.has('ticked')) {
      this.$services.enable('ticked');
    }

    this.pointerX = x;
    this.pointerY = y;

    let { scale } = this.$options;

    if (!event) {
      this.pointerScale = scale;
      return;
    }

    const shouldGrow =
      (event.target instanceof Element && event.target.matches(this.$options.growSelectors)) ||
      false;
    const shouldReduce =
      isDown ||
      (event.target instanceof Element && event.target.matches(this.$options.shrinkSelectors)) ||
      false;

    if (
      event.target.matches(this.$options.growSelectors) &&
      this.current !== event.target.closest('.card')
    ) {
      this.current = event.target.closest('.card');

      const { title } = this.current;
      const { year } = this.current.dataset;

      gsap.to(this.$refs.title, {
        duration: 1,
        scrambleText: {
          text: title,
          chars: 'upperAndLowerCase',
          revealDelay: 0.2,
          speed: 0.2,
        },
      });
      if (this.currentYear !== year) {
        gsap.to(this.$refs.year, {
          duration: 1,
          scrambleText: {
            text: year,
            chars: '1234567890',
            revealDelay: 0.2,
            speed: 0.2,
          },
        });
      }

      this.currentYear = year;
    }

    if (shouldGrow) {
      scale = this.$options.growTo;
      this.$el.classList.add('is-grow');
    } else {
      this.$el.classList.remove('is-grow');
    }

    if (shouldReduce) {
      scale = this.$options.shrinkTo;
    }

    this.pointerScale = scale;
  }
}
